import type { FaireProductEntity } from "../../entity_types/product";

export const p_zd22skp5ta: FaireProductEntity = {
  token: "p_zd22skp5ta",
  type: "product",
  name: "Woon Hibiscus Tea",
  brandToken: "b_th428x9zzy",
  brandName: "Woon",
  imageUrl: "https://cdn.faire.com/fastly/f37e314b784053578ff16e62beaacc9a6b195b6442b2ff08d940a48d536126f1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/456c4405258f9f8f2919bda9648acbf76931a97cf14a58b3a6884e976c800c78.jpeg",
    "https://cdn.faire.com/fastly/a2363ab905f4092b76ddbfdc9b5edc16fdfe381423e466370f9751be6572ad48.jpeg",
    "https://cdn.faire.com/fastly/61a27e880a9aa15fb67bf7858f36f338e12b0d4dbdade33023047f3ffea214c1.jpeg"
  ],
  priceDollars: 16,
  description: "A refreshing, tart and juicy loose leaf tea that is non-caffeinated and a crowd favorite!\n\n𝐈𝐧𝐬𝐭𝐫𝐮𝐜𝐭𝐢𝐨𝐧𝐬:\n• For hot tea, use 1 tsp tea for every 8 oz. of hot water and steep for 4-5 minutes.\n• For cold brew, place 2 tbsp tea in container and add 32 oz of water.\n• Steep for at least 4 hours or overnight, strain and enjoy!",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:27:50.871Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
